import "../css/index.css";
import React from "react";
import { makeStyles, useTheme, ThemeProvider } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import Divider from "@material-ui/core/Divider";
import { NavLink, useHistory } from "react-router-dom";
import Collapse from "@material-ui/core/Collapse";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FaceIcon from "@material-ui/icons/Face";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { theme } from "../css/theme";
import DialogPass from "../components/changepass";
const Gfunc = require("../Gfunc");

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  appBar: {
    background: theme.palette.primary.main,
    color: "white",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaper: {
    width: drawerWidth,
    boxSizing: "border-box",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  flexWrapper: {
    display: "flex",
    alignItems: "center",
  },
  link: {
    textDecoration: "none",
    color: "inherit",
  },
  link2: {
    textDecoration: "none",
    color: "inherit",
    paddingLeft: theme.spacing(2),
  },
}));

export default function PersistentDrawerLeft(props) {
  const classes = useStyles();
  const themes = useTheme();
  const [open, setOpen] = React.useState(false);
  const [openM, setOpenM] = React.useState(false);
  const [clicked, setClicked] = React.useState("");
  const [scope, setScope] = React.useState(props.scope);
  const history = useHistory();

  const routeChange = (newPath) => {
    history.push(newPath);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleOpenSubM = () => {
    setOpenM(!openM);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box display="flex">
        <CssBaseline />
        <AppBar
          position="fixed"
          className={open ? classes.appBarShift : classes.appBar}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              style={{ marginRight: 16, ...(open && { display: "none" }) }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div">
              <div className={classes.flexWrapper}>
                <p className="mobileBigTitle">{props.menu[props.cscope][3]}</p>
                <ArrowRightIcon />
                <p className="mobileSmallTitle">
                  {scope
                    ? props.menu[scope][3]
                    : props.menu[props.dp[props.cscope]][3]}
                </p>
              </div>
            </Typography>
            <div id="minfos" className="logoutTemplate">
              <div className="item1">
                <FaceIcon style={{ color: "white", fontSize: 18 }} />
                <DialogPass getInfo={Gfunc.getInfo} />
              </div>
              <div className="item2">
                <span id="vmag">
                  <select
                    onChange={(e) => props.basculerMagzin(e.target.value)}
                    id="vmag"
                    name="vmag"
                    value={localStorage.getItem("magid")}
                  >
                    {JSON.parse(Gfunc.getInfo().mags).map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </span>
              </div>
              <div className="item3">
                <span id="myCaiss">
                  Caisse:{" "}
                  <label className="mtn" id="caisseMtn2">
                    {Intl.NumberFormat().format(props.caisse)}
                  </label>{" "}
                  $
                </span>
              </div>
              <div className="item4">
                <ExitToAppIcon
                  style={{ color: "white", fontSize: 19, cursor: "pointer" }}
                  onClick={props.logout}
                  titleAccess="Déconnexion"
                />
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="persistent"
          anchor="left"
          open={open}
          classes={{ paper: classes.drawerPaper }}
        >
          <div className={classes.drawerHeader}>
            <IconButton onClick={handleDrawerClose}>
              {themes.direction === "ltr" ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </div>
          <Divider />
          <List>
            {props.menu !== undefined
              ? Object.keys(props.menu).map((key, index) => {
                  const value = props.menu[key];
                  if (value[2] === 1) {
                    return (
                      <ListItem
                        button
                        key={index}
                        onClick={() => {
                          handleOpenSubM();
                          routeChange("/" + key + "/" + props.dp[key]);
                          props.hendleSub(key);
                          setClicked(key);
                          setScope("");
                        }}
                      >
                        <ListItemIcon>
                          {value[0] === props.cscope ? (
                            <FiberManualRecordIcon
                              fontSize="small"
                              style={{ color: theme.palette.primary.main }}
                            />
                          ) : null}
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <NavLink
                              activeClassName="mselected"
                              className={classes.link}
                              aria-current="page"
                              to={"/" + key + "/" + props.dp[key]}
                              id={key}
                              onClick={() => {
                                props.hendleSub(key);
                                setClicked(key);
                                setScope("");
                              }}
                            >
                              {value[3]}
                            </NavLink>
                          }
                        />
                        {value[0] === props.cscope ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )}
                      </ListItem>
                    );
                  } else {
                    return (
                      <Collapse
                        key={index}
                        in={value[2] === 2 && value[0] === props.cscope}
                        timeout="auto"
                        unmountOnExit
                      >
                        <ListItem
                          button
                          style={{ paddingLeft: 32 }}
                          onClick={() => {
                            props.hendleSubsub(key);
                            setClicked("");
                            setScope(key);
                            routeChange("/" + props.cscope + "/" + key);
                          }}
                        >
                          <ListItemIcon>
                            {(key === props.dp[value[0]] &&
                              clicked === value[0]) ||
                            (key === props.scope && !clicked) ? (
                              <ArrowRightIcon
                                fontSize="large"
                                style={{ color: theme.palette.primary.main }}
                              />
                            ) : null}
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <NavLink
                                id={key}
                                activeClassName="mselected2"
                                className={classes.link2}
                                aria-current="page"
                                to={"/" + props.cscope + "/" + key}
                              >
                                {value[3]}
                              </NavLink>
                            }
                          />
                        </ListItem>
                      </Collapse>
                    );
                  }
                })
              : null}
          </List>
        </Drawer>
      </Box>
    </ThemeProvider>
  );
}
